import { API_BASE_URL } from '../constants';

export const generateTweets = async (formData, accessToken) => {
  try {
    const response = await fetch(`${API_BASE_URL}/generate-tweets`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${accessToken}`
      },
      body: formData,
    });

    if (!response.ok) {
      const errorData = await response.json();
      if (response.status === 500) {
        throw new Error('Video duration must be 20 minutes or less');
      }
      throw new Error(errorData.error || 'An error occurred while generating tweets');
    }

    const result = await response.json();
    return result;
  } catch (error) {
    console.error('Error generating tweets:', error);
    throw error;
  }
};

export const getTweetUsage = async (accessToken) => {
  try {
    const response = await fetch(`${API_BASE_URL}/get-tweet-usage`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${accessToken}`
      }
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || 'An error occurred while getting tweet usage');
    }

    const result = await response.json();
    return result;
  } catch (error) {
    console.error('Error getting tweet usage:', error);
    throw error;
  }
};
